$(document).ready(function () {
  $('.reviews-slider').slick({
    arrows: false,
    dots: true,
    autoplay: true,
  });
});
